// import React from 'react';
// import { NavLink } from 'react-router-dom';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import 'bootstrap/dist/js/bootstrap.bundle.min.js';
// import internLogo from '../assets/img/midc_logo_w.png';

// const Navbar = () => {
//   return (
//     <>
//       {/* Roboto Font */}
//       <link
//         href="https://fonts.googleapis.com/css2?family=Roboto:wght@700&display=swap"
//         rel="stylesheet"
//       />

//       {/* Navbar Shadow Wrapper with Gradient Shadow */}
//       <div className="navbar-shadow-wrapper">
//         <div className="container-fluid bg-white py-2 px-3" style={{ fontFamily: 'Roboto, sans-serif' }}>
//           <nav className="navbar navbar-expand-lg navbar-light bg-white w-100 p-0">
//             <div className="container-fluid p-0 d-flex flex-column flex-lg-row align-items-start align-items-lg-center justify-content-between">

//               {/* Logo + Toggle Button */}
//               <div className="d-flex w-100 justify-content-between align-items-center">
//                 <a className="navbar-brand" href="/">
//                   <img src={internLogo} alt="Logo" className="navbar-logo" />
//                 </a>

//                 {/* Toggle Button */}
//                 <button
//                   className="navbar-toggler d-lg-none"
//                   type="button"
//                   data-bs-toggle="collapse"
//                   data-bs-target="#navbarNav"
//                   aria-controls="navbarNav"
//                   aria-expanded="false"
//                   aria-label="Toggle navigation"
//                   style={{
//                     backgroundColor: 'transparent',
//                     border: 'none',
//                     padding: '10px',
//                   }}
//                 >
//                   <span className="navbar-toggler-icon" style={togglerStyle}></span>
//                   <span className="navbar-toggler-icon" style={togglerStyle}></span>
//                   <span className="navbar-toggler-icon" style={togglerStyle}></span>
//                 </button>
//               </div>

//               {/* Nav Links */}
//               <div className="collapse navbar-collapse w-100 mt-3 mt-lg-0" id="navbarNav">
//                 <ul className="navbar-nav ms-lg-auto mb-2 mb-lg-0">
//                   <li className="nav-item"><NavLink className="nav-link" to="/" style={navLinkStyle}>Home</NavLink></li>
//                   <li className="nav-item dropdown about-dropdown">
//                     <span className="nav-link dropdown-toggle" id="aboutDropdown" role="button">About Infrared</span>
//                     <ul className="dropdown-menu" aria-labelledby="aboutDropdown">
//                       <li><NavLink className="dropdown-item" to="/why">Why Infrared Imaging?</NavLink></li>
//                       <li><NavLink className="dropdown-item" to="/what">What Infrared Imaging?</NavLink></li>
//                     </ul>
//                   </li>
//                   <li className="nav-item"><NavLink className="nav-link" to="/service" style={navLinkStyle}>Service</NavLink></li>
//                   <li className="nav-item"><NavLink className="nav-link" to="/product" style={navLinkStyle}>Product</NavLink></li>
//                   <li className="nav-item"><NavLink className="nav-link" to="/gallery" style={navLinkStyle}>Gallery</NavLink></li>
//                   <li className="nav-item"><NavLink className="nav-link" to="/faq" style={navLinkStyle}>FAQ</NavLink></li>
//                   <li className="nav-item"><NavLink className="nav-link" to="/contact" style={navLinkStyle}>Contact</NavLink></li>
//                 </ul>

//                 {/* Appointment Button */}
//                 <a
//                   href="#book-appointment"
//                   className="btn text-white ms-lg-3 mt-3 mt-lg-0"
//                   style={{ background: 'linear-gradient(90deg, #D145EB, #F676DE)' }}
//                 >
//                   Book Appointment
//                 </a>
//               </div>
//             </div>
//           </nav>
//         </div>
//       </div>

//       {/* Custom Styles */}
//       <style>
//         {`
//           .navbar-shadow-wrapper {
//             background: linear-gradient(to bottom, rgba(209,69,235,0.15), white);
//             box-shadow: 0 10px 20px rgba(209, 69, 235, 0.25);
//             border-bottom-left-radius: 10px;
//             border-bottom-right-radius: 10px;
//           }

//           .navbar-logo {
//             height: 117px;
//             width: 500px;
//             object-fit: contain;
//           }

//           .navbar-toggler-icon {
//             background-color: #101010;
//             width: 30px;
//             height: 3px;
//             display: block;
//             margin: 5px auto;
//             border-radius: 2px;
//           }

//           .about-dropdown:hover .dropdown-menu {
//             display: block;
//             margin-top: 0;
//           }

//           .about-dropdown .dropdown-menu {
//             border-radius: 0.5rem;
//             background-color: #fff;
//             box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
//           }

//           .about-dropdown .dropdown-item {
//             padding: 10px 20px;
//             transition: background-color 0.2s ease;
//           }

//           .about-dropdown .dropdown-item:hover {
//             background: linear-gradient(90deg, #D145EB, #F676DE);
//             color: white;
//           }

//           @media (max-width: 1200px) {
//             .navbar-logo {
//               height: 90px;
//               width: auto;
//             }
//           }

//           @media (max-width: 992px) {
//             .navbar-logo {
//               height: 70px;
//               width: auto;
//             }
//           }

//           @media (max-width: 768px) {
//             .navbar-logo {
//               height: 60px;
//               width: auto;
//             }
//           }

//           @media (max-width: 576px) {
//             .navbar-logo {
//               height: 50px;
//               width: auto;
//             }
//           }
//         `}
//       </style>
//     </>
//   );
// };

// // Toggle icon bar style
// const togglerStyle = {
//   width: '30px',
//   height: '3px',
//   backgroundColor: '#101010',
//   display: 'block',
//   margin: '6px auto',
//   transition: 'all 0.3s ease',
// };

// // NavLink style
// const navLinkStyle = ({ isActive }) => ({
//   background: isActive ? 'linear-gradient(90deg, #D145EB, #F676DE)' : 'transparent',
//   color: isActive ? '#fff' : '#000',
//   borderRadius: isActive ? '10px' : '0px',
//   padding: isActive ? '10px 20px' : '8px 16px',
//   transition: 'all 0.3s ease',
// });

// export default Navbar;


import React from 'react';
import { NavLink } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import internLogo from '../assets/img/midc_logo_w.png';

const Navbar = () => {
  return (
    <>
      {/* Roboto Font */}
      <link
        href="https://fonts.googleapis.com/css2?family=Roboto:wght@700&display=swap"
        rel="stylesheet"
      />

      {/* Navbar Shadow Wrapper with Gradient Shadow */}
      <div className="navbar-shadow-wrapper">
        <div className="container-fluid bg-white py-2 px-3" style={{ fontFamily: 'Roboto, sans-serif' }}>
          <nav className="navbar navbar-expand-lg navbar-light bg-white w-100 p-0">
            <div className="container-fluid p-0 d-flex flex-column flex-lg-row align-items-start align-items-lg-center justify-content-between">

              {/* Logo + Toggle Button */}
              <div className="d-flex w-100 justify-content-between align-items-center">
                <a className="navbar-brand" href="/">
                  <img src={internLogo} alt="Logo" className="navbar-logo" />
                </a>

                {/* Toggle Button */}
                <button
                  className="navbar-toggler d-lg-none"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#navbarNav"
                  aria-controls="navbarNav"
                  aria-expanded="false"
                  aria-label="Toggle navigation"
                  style={{
                    backgroundColor: 'transparent',
                    border: 'none',
                    padding: '10px',
                  }}
                >
                  <span className="navbar-toggler-icon" style={togglerStyle}></span>
                  <span className="navbar-toggler-icon" style={togglerStyle}></span>
                  <span className="navbar-toggler-icon" style={togglerStyle}></span>
                </button>
              </div>

              {/* Nav Links */}
              <div className="collapse navbar-collapse w-100 mt-3 mt-lg-0" id="navbarNav">
                <ul className="navbar-nav ms-lg-auto mb-2 mb-lg-0">
                  <li className="nav-item"><NavLink className="nav-link" to="/" style={navLinkStyle}>Home</NavLink></li>
                  <li className="nav-item dropdown about-dropdown">
                    <span className="nav-link dropdown-toggle" id="aboutDropdown" role="button">About Infrared</span>
                    <ul className="dropdown-menu" aria-labelledby="aboutDropdown">
                      <li><NavLink className="dropdown-item" to="/why">Why Infrared Imaging?</NavLink></li>
                      <li><NavLink className="dropdown-item" to="/what">What Infrared Imaging?</NavLink></li>
                    </ul>
                  </li>
                  <li className="nav-item"><NavLink className="nav-link" to="/service" style={navLinkStyle}>Service</NavLink></li>
                  <li className="nav-item"><NavLink className="nav-link" to="/product" style={navLinkStyle}>Product</NavLink></li>

                  {/* Gallery Dropdown */}
                  <li className="nav-item dropdown gallery-dropdown">
                    <span className="nav-link dropdown-toggle" id="galleryDropdown" role="button">Gallery</span>
                    <ul className="dropdown-menu" aria-labelledby="galleryDropdown">
                      <li><NavLink className="dropdown-item" to="/gallery">Images</NavLink></li>
                      <li><NavLink className="dropdown-item" to="/video">Videos</NavLink></li>
                    </ul>
                  </li>

                  <li className="nav-item"><NavLink className="nav-link" to="/faq" style={navLinkStyle}>FAQ</NavLink></li>
                  <li className="nav-item"><NavLink className="nav-link" to="/contact" style={navLinkStyle}>Contact</NavLink></li>
                </ul>

                {/* Appointment Button */}
                <a
                  href="#book-appointment"
                  className="btn text-white ms-lg-3 mt-3 mt-lg-0"
                  style={{ background: 'linear-gradient(90deg, #D145EB, #F676DE)' }}
                >
                  Book Appointment
                </a>
              </div>
            </div>
          </nav>
        </div>
      </div>

      {/* Custom Styles */}
      <style>
        {`
          .navbar-shadow-wrapper {
            background: linear-gradient(to bottom, rgba(209,69,235,0.15), white);
            box-shadow: 0 10px 20px rgba(209, 69, 235, 0.25);
            border-bottom-left-radius: 10px;
            border-bottom-right-radius: 10px;
          }

          .navbar-logo {
            height: 117px;
            width: 500px;
            object-fit: contain;
          }

          .navbar-toggler-icon {
            background-color: #101010;
            width: 30px;
            height: 3px;
            display: block;
            margin: 5px auto;
            border-radius: 2px;
          }

          .about-dropdown:hover .dropdown-menu {
            display: block;
            margin-top: 0;
          }

          .gallery-dropdown:hover .dropdown-menu {
            display: block;
            margin-top: 0;
          }

          .dropdown-menu {
            border-radius: 0.5rem;
            background-color: #fff;
            box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
          }

          .dropdown-item {
            padding: 10px 20px;
            transition: background-color 0.2s ease;
          }

          .dropdown-item:hover {
            background: linear-gradient(90deg, #D145EB, #F676DE);
            color: white;
          }

          @media (max-width: 1200px) {
            .navbar-logo {
              height: 90px;
              width: auto;
            }
          }

          @media (max-width: 992px) {
            .navbar-logo {
              height: 70px;
              width: auto;
            }
          }

          @media (max-width: 768px) {
            .navbar-logo {
              height: 60px;
              width: auto;
            }
          }

          @media (max-width: 576px) {
            .navbar-logo {
              height: 50px;
              width: auto;
            }
          }
        `}
      </style>
    </>
  );
};

// Toggle icon bar style
const togglerStyle = {
  width: '30px',
  height: '3px',
  backgroundColor: '#101010',
  display: 'block',
  margin: '6px auto',
  transition: 'all 0.3s ease',
};

// NavLink style
const navLinkStyle = ({ isActive }) => ({
  background: isActive ? 'linear-gradient(90deg, #D145EB, #F676DE)' : 'transparent',
  color: isActive ? '#fff' : '#000',
  borderRadius: isActive ? '10px' : '0px',
  padding: isActive ? '10px 20px' : '8px 16px',
  transition: 'all 0.3s ease',
});

export default Navbar;
